import { render, staticRenderFns } from "./MenuWrapper.vue?vue&type=template&id=51b1b78d&scoped=true&"
import script from "./MenuWrapper.vue?vue&type=script&lang=js&"
export * from "./MenuWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MenuWrapper.vue?vue&type=style&index=0&id=51b1b78d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1b78d",
  null
  
)

export default component.exports